import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

const CAT_LABELS = {
  tout:          "Tout",
  transport:     "Transport",
  marche:        "Marché",
  hebergement:   "Hébergement",
  excursion:     "Excursion",
  restauration:  "Restauration",
  change:        "Change",
  rue:           "Rue",
  numerique:     "Numérique",
};

export function CategoryFilter({ categories, active, onChange }) {
  const chips = ["tout", ...categories];

  return (
    <div
      className="flex gap-2 overflow-x-auto pb-1"
      data-testid="category-filter"
      style={{ scrollbarWidth: "none" }}
    >
      {chips.map((cat) => (
        <button
          key={cat}
          onClick={() => onChange(cat)}
          data-testid={`filter-${cat}`}
          className={`flex-shrink-0 text-xs px-3 py-1.5 rounded-sm border transition-colors ${
            active === cat
              ? "bg-[#C17F59] text-[#F9F6F0] border-[#C17F59]"
              : "bg-[#F9F6F0] text-[#5C554E] border-[#DCD4C6] hover:border-[#C17F59] hover:text-[#C17F59]"
          }`}
          style={LORA}
        >
          {CAT_LABELS[cat] || cat}
        </button>
      ))}
    </div>
  );
}
